
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import Group from 'vux/src/components/group/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import FormPreview from 'vux/src/components/form-preview/index.vue'

import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import XHeader from 'vux/src/components/x-header/index.vue'

import InfiniteLoading from 'vue-infinite-loading';

export default {
components: {
Tab,
TabItem,
Divider,
XButton,
Group,
FormPreview,
Flexbox,
FlexboxItem,
InfiniteLoading,
XHeader
},

props: ['uid'],

data() {
return {
currentUser: 0,
orderList: {
currentPage: 1,
total: 0,
perPage: 0,
end: 0,
list: []
},
btnShowLoading: ''
}
},
created: function () {
document.title = '会员 ' + this.uid + '订单列表'
this.currentUser = this.uid;
},
methods: {
infiniteHandler($state) {
const url = this.tianYiWebUrl + '/wechat/order/ajaxGetListByUser';
this.btnShowLoading = true;
this.$http.get(url, {
params: {
uid: this.currentUser,
page: this.orderList['currentPage']
}
}).then(r => {
let res = r.data;
if (res.code === 200) {
let vRes = res.data;


this.orderList['list'] = [... this.orderList['list'], ...res.data.data];
this.orderList.currentPage = +res.data.current_page + 1;
if (vRes.total > vRes.per_page * vRes.current_page) {
this.orderList['perPage'] = res.data.per_page;
this.orderList['total'] = res.data.total;
this.btnShowLoading = false;
$state.loaded();
} else {
this.orderList['end'] = 1;
$state.complete();
}
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/uc/MemberOrder.vue